module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Boardwalk-Empire-S1.ca4bd28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Boardwalk-Empire-S1.jpg
// module id = XjRa
// module chunks = 0